import { useSelector } from 'react-redux';

export const useSmsVerificationCodeSelector = () => useSelector(state => state.verifications.smsVerificationCode);
